export default __webpack_public_path__ + "static/media/rating_active_1.0d2b83d5.png";